import Honeybadger from "@honeybadger-io/js"

export class AppError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "AppError"

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }

  notify() {
    Honeybadger.notify(this, {
      name: this.name,
      message: this.message,
      stack: this.stack
    })
  }
}
